import { QUICK_POST_V3_PORTAL_LAYERING_STYLE_ID } from "@circle-react/components/QuickPostV3/constants";
import { QUICK_POST_V3_PORTAL_LAYERING_CSS } from "@circle-react/components/QuickPostV3/portalLayeringStyles";
import { createPortal } from "react-dom";

interface LegacyEditorPortalLayeringStylesProps {
  active: boolean;
}

export const LegacyEditorPortalLayeringStyles = ({
  active,
}: LegacyEditorPortalLayeringStylesProps) => {
  if (!active) return null;

  return createPortal(
    <style id={QUICK_POST_V3_PORTAL_LAYERING_STYLE_ID}>
      {QUICK_POST_V3_PORTAL_LAYERING_CSS}
    </style>,
    document.head,
  );
};
